
export default class GoogleMap {

  constructor(root, config) {
    this.root = root;
    this.config = config;
    this.googleMap = null;
    this.points = null;

    this.init = this.init.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }

  handleResize() {
    google.maps.event.trigger(this.googleMap, 'resize');
    this.googleMap.setCenter(this.config.center);
  }

  init() {
    this.googleMap = new google.maps.Map(this.root, this.config);

    google.maps.event.addDomListener(window, 'resize', this.handleResize);

    this.points = window.hopkinsClientLocations.map(location => {
      return new google.maps.Marker({
        position: {
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng),
        },
        icon: '/assets/images/map-marker.svg',
        map: this.googleMap,
      });
    });
  }

};



// WEBPACK FOOTER //
// ./components/google-map.js